// Localstorage key for dismissed items
const KEY = "alert-bar-dismissed";

// Get a set of alert bar IDs which have been dismissed, from localstorage
function getDismissedIds(): Set<string> {
  const dismissedIdsString = localStorage.getItem(KEY);
  return new Set(
    dismissedIdsString == null ? [] : JSON.parse(dismissedIdsString)
  );
}

// Add an alert bar ID to the list of those which have been dismissed,
// and store in localstorage
function addDismissedId(id: string): void {
  const dismissedIds = getDismissedIds();
  dismissedIds.add(id);
  localStorage.setItem(KEY, JSON.stringify([...dismissedIds]));
}

// Loop through alert bars on page
for (const alertBar of document.querySelectorAll(
  ".alert-bar[data-alert-id]"
) as NodeListOf<HTMLElement>) {
  const id = alertBar.dataset.alertId as string;

  // If it has been dismissed, do nothing
  if (getDismissedIds().has(id)) continue;

  // This alert has not been dismissed; show it
  alertBar.hidden = false;

  // Set up the click action for its dismiss button
  const dismissButton = alertBar.querySelector("button.alert-bar__dismiss");
  if (dismissButton == null)
    throw new Error("Alert bar has ID but no dismiss button");
  dismissButton.addEventListener("click", () => {
    addDismissedId(id);
    alertBar.hidden = true;
  });
}
